import { render, staticRenderFns } from "./AgentTemperatureMonitor.vue?vue&type=template&id=56c9485d"
import script from "./AgentTemperatureMonitor.vue?vue&type=script&lang=js"
export * from "./AgentTemperatureMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports